import { Box, Grid, InputLabel, MenuItem, Typography } from "@mui/material";
import { useState } from "react";
import { string } from "../../../../../constants/string";
import FileUpload from "../../../../../components/FileUpload";
import theme from "../../../../../theme";
import Input from "../../../../../components/Input";
import { useTenPercentBankDetailsStore } from "../../../../../store/useTenPercentBankDetailsStore";
import { isValidContactNumber } from "../../../../../utils/validators";
import { useBankNames } from "../../../../../hooks/useBankNames";
import { useTenPercentClaimFormStore } from "../../../../../store/useTenPercentClaimFormStore";
import ButtonComp from "../../../../../components/Button";

export default function TenpercentBanking({
  handleBack,
  handleTenPercentBankingInfoNext,
}: any) {

  const accountTypeMap: Record<string, any> = {
    "Cheque Account": 1,
    "Saving Account": 2,
    "Transmission Account": 3,
  };

  const [errors, setErrors] = useState<{ [key: string]: string }>({
    payableTo: "",
    relationship: "",
    accountHolder: "",
    bankName: "",
    accountNumber: "",
    branchName: "",
    branchCode: "",
    accountType: "",
    passportNumber: "",
    sourceOfFunds: "",
    occupation: "",
    emailAddress: "",
    nationality: "",
    countryOfResidence: "",
    countryOfBirth: "",
    signature_document: "",
    bank_statement: "",
    cellPhoneNumber: "",
    accountName: "",
  });
  const [showErrors, setShowErrors] = useState(false);

  const tenPercentBankDetails = useTenPercentBankDetailsStore(
    (state) => state.tenPercentBankDetails
  );

  const setTenPercentBankDetails = useTenPercentBankDetailsStore(
    (state) => state.setTenPercentBankDetails
  );

  const addTenPercentDocument = useTenPercentClaimFormStore(
    (state) => state.addTenPercentDocument
  );

  const tenPercentDocuments = useTenPercentClaimFormStore(
    (state) => state.tenPercentdocuments
  );

  const { bankOptions } = useBankNames();

  const handleChange = (field: string, value: string) => {
    const updated = { ...tenPercentBankDetails, [field]: value };
     if (field === "accountType") {
          setTenPercentBankDetails({
            ...tenPercentBankDetails,
            accountType: value,
            accountTypeId: accountTypeMap[value] || "",
          });
        } else {
          setTenPercentBankDetails(updated);
        }
   // setTenPercentBankDetails(updated);
    if (showErrors) {
      setErrors((prev) => {
        const newErrors = { ...prev };

        if (!value) {
          newErrors[field] = `Please enter ${field
            .replace(/([A-Z])/g, " $1")
            .toLowerCase()}`;
        } else {
          newErrors[field] = "";
        }

        if (field === "emailAddress") {
          const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
          if (value && !emailRegex.test(value)) {
            newErrors.emailAddress = "Invalid email address";
          }
        }

        if (field === "cellPhoneNumber" && typeof value === "string") {
          newErrors.cellPhoneNumber = !isValidContactNumber(value.trim())
            ? "Invalid contact number (10 digits only)"
            : "";
        }

        return newErrors;
      });
    }
  };

  const validateTenPercentBankForm = () => {
    const fieldsToValidate = [
      "bankName",
      "accountName",
      "branchCode",
      "accountType",
      "accountNumber",
      "branchName",
    ];

    const newErrors: any = {};
    let isValid = true;

    fieldsToValidate.forEach((field) => {
      const value =
        tenPercentBankDetails[field as keyof typeof tenPercentBankDetails];
      if (!value) {
        newErrors[field] = `Please enter ${field
          .replace(/([A-Z])/g, " $1")
          .toLowerCase()}`;
        isValid = false;
      }
    });

    if (!tenPercentDocuments.bank_proof) {
      newErrors.bank_proof = "Please upload a document";
      isValid = false;
    }

    setErrors((prev) => ({ ...prev, ...newErrors }));
    return isValid;
  };
  return (
    <Box component="form" noValidate autoComplete="off" mt={6} width="100%">
      <Grid container spacing={3}>
        <Grid size={{xs:12,md:4}}>
          <Input
            select
            fullWidth
            label="Bank name"
            variant="outlined"
            value={tenPercentBankDetails?.bankName ?? ""}
            onChange={(e: any) => handleChange("bankName", e.target.value)}
            error={showErrors && Boolean(errors.bankName)}
            helperText={showErrors ? errors.bankName : ""}
            SelectProps={{
              displayEmpty: true,
              renderValue: (selected: any) =>
                selected ? (
                  selected
                ) : (
                  <span style={{ color: "#aaa" }}>Select Bank Name</span>
                ),
              MenuProps: {
                PaperProps: {
                  sx: {
                    backgroundColor: "#ffffff",
                    borderRadius: "12px",
                    maxHeight: "300px",
                  },
                },
              },
            }}
          >
            {bankOptions.map((bank) => (
              <MenuItem
                key={bank}
                value={bank}
                sx={{
                  background: "background.default",
                  borderBottom: ` 1px solid ${theme.palette.grey[200]}`,
                }}
              >
                {bank}
              </MenuItem>
            ))}
          </Input>
        </Grid>
        <Grid size={{xs:12,md:4}}>
          <Input
            fullWidth
            label="Account Name"
            variant="outlined"
            value={tenPercentBankDetails.accountName}
            onChange={(e: any) => handleChange("accountName", e.target.value)}
            error={showErrors && Boolean(errors.accountName)}
            helperText={showErrors ? errors.accountName : ""}
          />
        </Grid>
        <Grid size={{xs:12,md:4}}>
          <Input
            fullWidth
            label="Branch code"
            variant="outlined"
            value={tenPercentBankDetails.branchCode}
            onChange={(e: any) => handleChange("branchCode", e.target.value)}
            error={showErrors && Boolean(errors.branchCode)}
            helperText={showErrors ? errors.branchCode : ""}
          />
        </Grid>
        <Grid size={{xs:12,md:4}}>
          <Input
            select
            fullWidth
            label={string.bankingInfo.accountType}
            variant="outlined"
            value={tenPercentBankDetails.accountType}
            onChange={(e: any) => handleChange("accountType", e.target.value)}
            error={showErrors && Boolean(errors.accountType)}
            helperText={showErrors ? errors.accountType : ""}
            SelectProps={{
              displayEmpty: true,
              renderValue: (selected: any) =>
                selected ? (
                  selected
                ) : (
                  <span style={{ color: "#aaa" }}>Select Account Type</span>
                ),
              MenuProps: {
                PaperProps: {
                  sx: {
                    backgroundColor: "#ffffff",
                    borderRadius: "12px",
                    maxHeight: "300px",
                  },
                },
              },
            }}
          >
            <MenuItem
            value="Cheque Account"
            sx={{
              background: "background.default",
            }}
          >
            Cheque Account
          </MenuItem>
          <MenuItem
            value="Transmission Account"
            sx={{
              background: "background.default",
            }}
          >
            Transmission Account
          </MenuItem>
          <MenuItem
            value="Saving Account"
            sx={{ background: "background.default" }}
          >
            Saving Account
          </MenuItem>
          </Input>
        </Grid>
        <Grid size={{xs:12,md:4}}>
          <Input
            fullWidth
            label="Account number"
            variant="outlined"
            value={tenPercentBankDetails.accountNumber}
            onChange={(e: any) => handleChange("accountNumber", e.target.value)}
            error={showErrors && Boolean(errors.accountNumber)}
            helperText={showErrors ? errors.accountNumber : ""}
          />
        </Grid>
        <Grid size={{xs:12,md:4}}>
          <Input
            fullWidth
            label={string.bankingInfo.branchName}
            variant="outlined"
            value={tenPercentBankDetails.branchName}
            onChange={(e: any) => handleChange("branchName", e.target.value)}
            error={showErrors && Boolean(errors.branchName)}
            helperText={showErrors ? errors.branchName : ""}
          />
        </Grid>
        <Grid size={{ xs: 12, md: 12 }} textAlign={"left"}>
          <InputLabel sx={{ fontWeight: 600, mb: 1, fontSize: 18 }}>
            {string.bankingInfo.proofOfBanking}
          </InputLabel>
          <FileUpload
            inputId="bank_proof"
            fileName={tenPercentDocuments.bank_proof?.name ?? ""}
            onChange={async (e) => {
              const file = e.target.files?.[0];
              if (file) {
                  if (file.size > 2 * 1024 * 1024) {
                    setErrors((prev) => ({
                      ...prev,
                      bank_proof: "File must be less than 2MB",
                    }));
                    return;
                  }
                addTenPercentDocument("bank_proof", file);
                handleChange("bank_proof", file.name);
                 setErrors((prev) => {
                    const newErrors = { ...prev };
                    delete newErrors.bank_proof;
                    return newErrors;
                  });
              }
            }}
          />
          {errors.bank_proof && (
            <Typography
              sx={{
                color: "error.main",
                fontSize: "0.8rem",
                textAlign: "left",
              }}
            >
              {errors.bank_proof }
            </Typography>
          )}
        </Grid>
      </Grid> 
      <Box
        sx={{
          width: "100%",
          display: "flex",
          justifyContent: "space-between",
          py: 4,
          flexDirection: { xs: "column", sm: "row" },
          gap: { xs: 2 },
        }}
      >
        <ButtonComp
          variant="outlined"
          height={40}
          fontSize="16px"
          width={200}
          onClick={handleBack}
        >
          {string.claims.back}
        </ButtonComp>
        <ButtonComp
          variant="contained"
          height={40}
          fontSize="16px"
          width={200}
          onClick={() => {
            setShowErrors(true);

            if (validateTenPercentBankForm()) {
              handleTenPercentBankingInfoNext?.(tenPercentBankDetails);
            }
          }}
        >
          {string.claims.submit}
        </ButtonComp>
      </Box>
    </Box>
  );
}
